module.exports = __webpack_public_path__ + "static/media/aragon56.edc54615.jpg";